const API_BASE_URL = process.env.VUE_APP_API_BASE_URL ?? 'https://api.adx.com.ru';

export default {
	baseURL: API_BASE_URL,
	isFatal: false,
};
